var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSketch: "http://www.bohemiancoding.com/sketch/ns",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "movie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    sketchType: "MSPage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screens/review",
    sketchType: "MSArtboardGroup",
    transform: "translate(-512.000000, -36.000000)",
    fill: "#FFFFFF",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    sketchType: "MSLayerGroup",
    transform: "translate(47.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tv",
    transform: "translate(446.000000, 26.000000)",
    sketchType: "MSShapeGroup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.090332,0 L21,0 C19.9,0 19,0.9 19,2 L19,14 C19,15.1 19.9,16 21,16 L37,16 C38.1,16 39,15.1 39,14 L39,2 C39,1.04785156 37.726888,0 37.090332,0 Z M36.5,7 C36.7761424,7 37,6.77614237 37,6.5 C37,6.22385763 36.7761424,6 36.5,6 C36.2238576,6 36,6.22385763 36,6.5 C36,6.77614237 36.2238576,7 36.5,7 Z M36.5,4 C36.7761424,4 37,3.77614237 37,3.5 C37,3.22385763 36.7761424,3 36.5,3 C36.2238576,3 36,3.22385763 36,3.5 C36,3.77614237 36.2238576,4 36.5,4 Z M21,3.00247329 C21,2.44882258 21.4474894,2 21.9985023,2 L33.0014977,2 C33.5529553,2 34,2.45576096 34,3.00247329 L34,12.9975267 C34,13.5511774 33.5525106,14 33.0014977,14 L21.9985023,14 C21.4470447,14 21,13.544239 21,12.9975267 L21,3.00247329 Z",
    id: "movie"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.a931614af2a8d8194cd2c879be4536eb.svg";
export { ForwardRef as ReactComponent };